// extracted by mini-css-extract-plugin
export var DifferenceIcon = "DashboardDifference-module--DifferenceIcon--CjaQg";
export var DifferenceLabel = "DashboardDifference-module--DifferenceLabel--i7CXB";
export var DifferenceText = "DashboardDifference-module--DifferenceText--AA3g7";
export var DifferenceWrapper = "DashboardDifference-module--DifferenceWrapper--hxPjX";
export var grey = "DashboardDifference-module--grey--jU9GJ";
export var negative = "DashboardDifference-module--negative--a+MxG";
export var positive = "DashboardDifference-module--positive--n3mEi";